import { Tabs, Collapse } from "antd";
import type { CollapseProps, TabsProps } from "antd";

export default function TabsAndAccordions() {
  // Tabs OnChange
  const onChange = (key: string) => {
    console.log(key);
  };

  const tabItems: TabsProps["items"] = [
    {
      key: "1",
      label: "Tab 1",
      children: "Content of Tab Pane 1",
    },
    {
      key: "2",
      label: "Tab 2",
      children: "Content of Tab Pane 2",
    },
    {
      key: "3",
      label: "Tab 3",
      children: "Content of Tab Pane 3",
    },
  ];

  // Accordion Content
  const text = `
    A dog is a type of domesticated animal.
    Known for its loyalty and faithfulness,
    it can be found as a welcome guest in many households across the world.
  `;

  // Accordion Panel
  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "This is panel header 1",
      children: <p>{text}</p>,
    },
    {
      key: "2",
      label: "This is panel header 2",
      children: <p>{text}</p>,
    },
    {
      key: "3",
      label: "This is panel header 3",
      children: <p>{text}</p>,
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="pageName">
            <h4>Tabs and Accordions</h4>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-lg-12">
          <Tabs defaultActiveKey="1" items={tabItems} onChange={onChange} />
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-lg-12">
          <Collapse accordion items={items} defaultActiveKey={["1"]} />
        </div>
      </div>
    </div>
  );
}
